import * as React from "react"
import { ChevronDownIcon } from "lucide-react"

import { cn } from "@/lib/utils"

// Proporciones del DS (mismas que Input / Select): h-11, borde 1.5px, radio 12px.
//
// `size="compacto"` es el tamaño del PROTOTIPO —33px de alto, radio 9, letra
// de 11.5— y existe porque el módulo de referencias de mercado se dibujó con
// controles un 25 % más bajos que el resto de la aplicación. Va acá y no como
// override de una pantalla para que la densidad quede disponible en todas.
// y px-3.5. Venía en las medidas stock de shadcn (h-9, borde 1px, px-3), que al
// lado de un Input del DS se veía otro control. El wrapper sigue el ancho del
// select (`w-full`) en vez de `w-fit`: dentro de un formulario el campo ocupa
// la columna, y desde `className` no se puede corregir el ancho del padre.
function NativeSelect({
  className,
  size = "default",
  ...props
}: Omit<React.ComponentProps<"select">, "size"> & { size?: "compacto" | "sm" | "default" }) {
  return (
    <div
      className="group/native-select relative w-full has-[select:disabled]:opacity-50"
      data-slot="native-select-wrapper"
    >
      <select
        data-slot="native-select"
        data-size={size}
        className={cn(
          "border-input placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 dark:hover:bg-input/50 h-11 w-full min-w-0 appearance-none rounded-md border-[1.5px] bg-campo px-3.5 py-2 pr-9 text-sm font-semibold transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed data-[size=sm]:h-9 data-[size=sm]:py-1 data-[size=compacto]:h-[2.0625rem] data-[size=compacto]:rounded-[0.5625rem] data-[size=compacto]:py-0 data-[size=compacto]:pr-[1.875rem] data-[size=compacto]:pl-[0.6875rem] data-[size=compacto]:text-[0.71875rem] data-[size=compacto]:font-semibold",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          className
        )}
        {...props}
      />
      <ChevronDownIcon
        className="text-ink-muted pointer-events-none absolute top-1/2 right-3.5 size-4 -translate-y-1/2 select-none"
        aria-hidden="true"
        data-slot="native-select-icon"
      />
    </div>
  )
}

function NativeSelectOption({ ...props }: React.ComponentProps<"option">) {
  return <option data-slot="native-select-option" {...props} />
}

function NativeSelectOptGroup({
  className,
  ...props
}: React.ComponentProps<"optgroup">) {
  return (
    <optgroup
      data-slot="native-select-optgroup"
      className={cn(className)}
      {...props}
    />
  )
}

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption }
